import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const BannerEditModal = ({ show, onClose, section, onSave, saving }) => {
    const [title, setTitle] = useState(section?.title || '');
    const [url, setUrl] = useState(section?.url || '');
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(
        section?.bannerImg ? `${process.env.REACT_APP_IMAGE_URL}${section.bannerImg}` : ''
    );

    useEffect(() => {
        // Cleanup the object URL when component unmounts or previewUrl changes
        return () => {
            if (previewUrl && previewUrl.startsWith('blob:')) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile) {
            const imageUrl = URL.createObjectURL(selectedFile);
            setPreviewUrl(imageUrl);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('id', section.id);
        formData.append('title', title);
        formData.append('url', url);
        if (file) {
            formData.append('bannerImg', file); // key must match your backend field name
        }

        onSave(formData);
    };

    return (
        <Modal show={show} onHide={onClose} centered className='editModel'>
            <Modal.Header closeButton>
                <Modal.Title>Edit Banner</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group controlId="formTitle" className="mb-3">
                        <Form.Label>Section Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="formUrl" className="mb-3">
                        <Form.Label>URL</Form.Label>
                        <Form.Control
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>Banner Image</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                        {previewUrl && (
                            <div className="mt-3">
                                <img
                                    src={previewUrl}
                                    alt="Banner Preview"
                                    className="img-fluid rounded border"
                                    style={{ maxHeight: '150px' }}
                                />
                            </div>
                        )}
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={saving}>
                        {saving ? <Spinner animation="border" size="sm" /> : 'Save'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BannerEditModal;
